import type { PropFirm } from '../../types';
import PropFirmRowCard from './PropFirmRowCard';

type Variant = 'compact' | 'full';
type CTAContext = 'homepage' | 'bestFirms';
type HighlightTone = 'gold' | 'green' | 'blue';

export interface PropFirmComparisonSectionProps {
  title: string;
  firms: PropFirm[];
  variant?: Variant;
  ctaContext?: CTAContext;
  limit?: number;
  bestDealFirmId?: string;
  featuredFirmId?: string;
  visibleColumnKeys?: string[];
  highlightedFirmId?: string;
  highlightLabel?: string;
  highlightTone?: HighlightTone;
  getMainPrice: (firm: PropFirm) => PropFirm['pricing'][0];
}

export default function PropFirmComparisonSection({
  title,
  firms,
  variant = 'full',
  ctaContext = 'bestFirms',
  limit,
  bestDealFirmId,
  featuredFirmId,
  visibleColumnKeys,
  highlightedFirmId,
  highlightLabel,
  highlightTone,
  getMainPrice,
}: PropFirmComparisonSectionProps) {
  const list = typeof limit === 'number' ? firms.slice(0, limit) : firms;
  if (!list.length) return null;

  return (
    <div className="mb-10">
      <h3 className="text-xl font-bold text-yellow-400 mb-4 px-4">{title}</h3>
      <div className="space-y-4">
        {list.map((firm, idx) => {
          const price = getMainPrice(firm);
          const isBestDeal = bestDealFirmId ? firm.id === bestDealFirmId : idx === 0;
          const isFeatured = !!featuredFirmId && firm.id === featuredFirmId;
          const isHighlighted = !!highlightedFirmId && firm.id === highlightedFirmId;

          return (
            <PropFirmRowCard
              key={firm.id}
              propFirm={firm}
              price={price}
              variant={variant}
              ctaContext={ctaContext}
              isBestDeal={isBestDeal}
              isFeatured={isFeatured}
              visibleColumnKeys={visibleColumnKeys}
              highlightLabel={isHighlighted ? highlightLabel : undefined}
              highlightTone={highlightTone}
            />
          );
        })}
      </div>
    </div>
  );
}
